import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';

function LoginPage(props) {
    const [password, setPassword] = useState('');
    const loginForm = useRef();

    useEffect(() => {
        if (props.model.errors.length > 0 && loginForm.current) {
            loginForm.current.showError('Password', () => props.model.errors[0].messages.join(';'));
            loginForm.current.validateAll();
        }
    }, [props.model.errors]);

    const handlePasswordChange = useCallback(value => {
        loginForm.current.hideError('Password');
        setPassword(value.trim());
    }, [setPassword]);

    const beforeSubmit = new Promise(resolve => (
        setTimeout(() => (
            resolve()
        ), 10)
    ));

    const forgotPasswordLink = `/Account/ForgotPassword?ReturnUrl=${encodeURIComponent(props.model.returnUrl || '/')}`;

    return (
        <AuthWrapper
            heading="Enter Password"
            subtitle={props.model.username}
            goBackUrl={`/Account/Login?returnUrl=${encodeURIComponent(props.model.returnUrl)}`}
        >
            <Validation.Form method="post" ref={loginForm} resolveBeforeSubmit={beforeSubmit} action="/Account/Login">
                <input type="hidden" name="ReturnUrl" value={props.model.returnUrl || ''} />
                <input type="hidden" name="Username" value={props.model.username || ''} />
                <section className="sten-content__section">
                    <Validation.Wrapper validations={{ required: true }}>
                        <Input
                            name="Password"
                            className="sten-input--sm"
                            type="password"
                            id="Password"
                            placeholder="Password"
                            value={password}
                            onChange={handlePasswordChange}
                            showKeyboard
                        />
                    </Validation.Wrapper>
                </section>
                <section className="sten-content__section">
                    <Validation.Button className="btn btn--primary btn--sm col-24" value="login">
                        Login
                    </Validation.Button>
                </section>
                <section className="sten-content__section sten-content__section--lg">
                    <div className="text-center">
                        <a className="sten-link" href={forgotPasswordLink}>
                            Forgot password?
                        </a>
                    </div>
                </section>
                <input name="__RequestVerificationToken" type="hidden" value={props.token} />
            </Validation.Form>
        </AuthWrapper>
    );
}

LoginPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default LoginPage;
